module.exports = "<div class=\"badge badge-square\"\n  [ngClass]=\"className\">\n  {{ data }}\n</div>\n";